import React from 'react'

function Discord() {
    return (
        <div>
            <h1>Discord</h1>
        </div>
    )
}

export default Discord
